var Assam = "Assam";
var Bihar = "Bihar";
var Chandigarh = "Chandigarh";
var Chhattisgarh = "Chhattisgarh";
var Delhi = "Delhi";
var Goa = "Goa";
var Gujarat = "Gujarat";
var Haryana = "Haryana";
var Jharkhand = "Jharkhand";
var Karnataka = "Karnataka";
var Kerala = "Kerala";
var Lakshwadeep = "Lakshwadeep";
var Maharashtra = "Maharashtra";
var Manipur = "Manipur";
var Meghalaya = "Meghalaya";
var Mizoram = "Mizoram";
var Nagaland = "Nagaland";
var Orrisa = "Orrisa";
var Puducherry = "Puducherry";
var Punjab = "Punjab";
var Rajasthan = "Rajasthan";
var Sikkim = "Sikkim";
var Telangana = "Telangana";
var Tripura = "Tripura";
var Uttrakhand = "Outtrakhand";
var INStates = {
	"Andaman and Nicobar Islands": "Quần đảo Andaman và Nicobar",
	"Andhra Pradesh": "Andhra Pradesh",
	"Arunachal Pradesh": "Arunachal Pradesh",
	Assam: Assam,
	Bihar: Bihar,
	Chandigarh: Chandigarh,
	Chhattisgarh: Chhattisgarh,
	"Dadra & Nagar Haveli": "Dadra & Nagar Haveli",
	"Daman & Diu": "Daman & Diu",
	Delhi: Delhi,
	Goa: Goa,
	Gujarat: Gujarat,
	Haryana: Haryana,
	"Himachal Pradesh": "Himachal Pradesh",
	"Jammu and Kashmir": "Jammu và Kashmir",
	Jharkhand: Jharkhand,
	Karnataka: Karnataka,
	Kerala: Kerala,
	Lakshwadeep: Lakshwadeep,
	"Madhya Pradesh": "Madhya Pradesh",
	Maharashtra: Maharashtra,
	Manipur: Manipur,
	Meghalaya: Meghalaya,
	Mizoram: Mizoram,
	Nagaland: Nagaland,
	Orrisa: Orrisa,
	Puducherry: Puducherry,
	Punjab: Punjab,
	Rajasthan: Rajasthan,
	Sikkim: Sikkim,
	"Tamil Nadu": "Tamil Nadu",
	Telangana: Telangana,
	Tripura: Tripura,
	"Uttar Pradesh": "Uttar Pradesh",
	Uttrakhand: Uttrakhand,
	"West Bengal": "Tây Bengal"
};

export { Assam, Bihar, Chandigarh, Chhattisgarh, Delhi, Goa, Gujarat, Haryana, Jharkhand, Karnataka, Kerala, Lakshwadeep, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Orrisa, Puducherry, Punjab, Rajasthan, Sikkim, Telangana, Tripura, Uttrakhand, INStates as default };
